"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgActiveSubscribeBell = function SvgActiveSubscribeBell(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 0.026,
    x2: 0.5,
    y1: 0.976,
    x1: 0.5,
    id: "active-subscribe-bell_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27E4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15C1C6",
    offset: 0.178
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E90EA",
    offset: 0.371
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776CF2",
    offset: 0.574
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#995EE3",
    offset: 0.798
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB47D1",
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    stroke: "#17181A",
    fill: "url(#active-subscribe-bell_svg__a)",
    d: "M14.808 4.9a1.298 1.298 0 1 0-1.703-.293c-1.034.013-1.938.294-2.681.878-.928.727-1.538 1.87-1.88 3.348-.643 2.778-1.726 4.107-3.082 4.404l-.089.02-.076.048c-.366.238-.705.556-.78.988-.084.472.177.856.492 1.128l.324-.373-.324.373c.456.395 1.332.85 2.45 1.272.443.166.932.33 1.459.486l-.09.19c-.115.246-.19.553-.231.785A2.896 2.896 0 0 0 14.3 19.16c.048-.273.056-.598.03-.858l-.016-.153c.61.043 1.183.059 1.704.053 1.195-.014 2.174-.142 2.737-.357.39-.148.766-.42.85-.892.076-.431-.133-.847-.397-1.195l-.054-.072-.077-.049c-1.173-.742-1.736-2.361-1.39-5.192.184-1.506.002-2.788-.621-3.789-.506-.813-1.272-1.392-2.258-1.756z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M8.919 17.19s.001-.018.108 0c.169.027.39.125.595.215.178.08.328.125.486.163.118.027.225.066.324.108.071.029.178.015.217.054.038.038.054.054.108.054s.091.025.162.054c.1.041.162 0 .27 0 .054 0 .108.054.216.054.109 0 .217.054.325.054.054 0 .108.054.162.054h.162c.108 0 .166-.02.216 0 .07.03.162.054.27.054.109 0 .163.054.27.054h.866c.054 0 .054.054.108.054h.108"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgActiveSubscribeBell);
var _default = exports["default"] = Memo;